import type { SVGProps } from 'react';

/**
 * Google's four-colour "G", inlined. Decorative: the button's own text carries
 * the accessible name, so this is aria-hidden and must stay that way — Google's
 * branding rules require the mark be shown unmodified, which also means it
 * can't inherit currentColor like the rest of the app's icons.
 */
export function GoogleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" {...props}>
      <path
        d="M23.52 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.46a5.53 5.53 0 0 1-2.4 3.63v3h3.87c2.26-2.09 3.59-5.17 3.59-8.82Z"
        fill="#4285F4"
      />
      <path
        d="M12 24c3.24 0 5.96-1.08 7.94-2.91l-3.88-3a7.23 7.23 0 0 1-10.75-3.8H1.29v3.09A12 12 0 0 0 12 24Z"
        fill="#34A853"
      />
      <path
        d="M5.31 14.29a7.19 7.19 0 0 1 0-4.58V6.62H1.29a12 12 0 0 0 0 10.76l4.02-3.09Z"
        fill="#FBBC05"
      />
      <path
        d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.44-3.44C17.95 1.19 15.24 0 12 0A12 12 0 0 0 1.29 6.62l4.02 3.09A7.15 7.15 0 0 1 12 4.75Z"
        fill="#EA4335"
      />
    </svg>
  );
}
